import { getErrorMessage } from "@utils/getErrorMessage";
import { createSignal } from "solid-js";
import {
	cancelMyAskPageSubscription,
	getMyAskPageSubscriptions,
} from "@/client";

export const useAskPageUnsubscribe = (handle: string) => {
	const [busy, setBusy] = createSignal(false);
	const [error, setError] = createSignal<string | null>(null);

	const unsubscribe = async (): Promise<boolean> => {
		setError(null);
		setBusy(true);
		try {
			const list = await getMyAskPageSubscriptions({
				query: { page_size: 100, status: "active" },
			});
			const normalized = handle.trim().replace(/^@/, "").toLowerCase();
			const match = (list.data?.subscriptions ?? []).find(
				(row) => row.influencer.handle?.toLowerCase() === normalized,
			);
			if (!match?.id) {
				setError("Could not find an active subscription to cancel.");
				return false;
			}

			const cancelled = await cancelMyAskPageSubscription({
				path: { id: match.id },
			});
			if (cancelled.error) {
				setError(
					getErrorMessage(cancelled.error, "Could not unsubscribe. Try again."),
				);
				return false;
			}

			window.location.reload();
			return true;
		} catch (thrown) {
			setError(getErrorMessage(thrown, "Could not unsubscribe. Try again."));
			return false;
		} finally {
			setBusy(false);
		}
	};

	return { unsubscribe, busy, error };
};
